import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

export const NAVIGATION = [
  {
    segment: 'project/projectList',
    title: '사업관리',
    icon: <AssessmentOutlinedIcon />,
  },
  {
    segment: 'project/PlannedProjectList',
    title: '사업관리',
    hidden: true,
  },
  {
    segment: 'account/companyAccountList',
    title: '거래처 관리',
    icon: <ManageSearchOutlinedIcon />,
  },
  {
    segment: 'profile/list',
    title: '프로필 관리',
    icon: <ManageAccountsOutlinedIcon />,
  },
  {
    segment: 'setting/userList',
    title: '설정',
    icon: <SettingsOutlinedIcon />,
  },
  {
    kind: 'divider',
  },
  {
    segment: 'logout',
    title: '로그아웃',
    icon: <LogoutOutlinedIcon />,
  },
];

export const USER_NAVIGATION = [
  {
    segment: 'project/projectList',
    title: '사업관리',
    icon: <AssessmentOutlinedIcon />,
  },
  {
    segment: 'project/PlannedProjectList',
    title: '사업관리',
    hidden: true,
  },
  {
    segment: 'account/companyAccountList',
    title: '거래처 관리',
    icon: <ManageSearchOutlinedIcon />,
  },
  {
    segment: 'profile/list',
    title: '프로필 관리',
    icon: <ManageAccountsOutlinedIcon />,
  },
  {
    kind: 'divider',
  },
  {
    segment: 'logout',
    title: '로그아웃',
    icon: <LogoutOutlinedIcon />,
  },
];
